import type { CheckboxProps } from 'antd'
import type { FC } from 'react'
import type { CellProps } from '../../../interfaces'

import { Checkbox } from 'antd'
import styled from 'styled-components'

export type TCheckBoxCell = CellProps & Omit<CheckboxProps, 'title'>

const CheckBoxWrap = styled.div`
  display: flex;
  justify-content: center;
`

const CheckBoxCell: FC<TCheckBoxCell> = ({ title, key, dataIndex, ...checkboxProps }) => {
  return (
    <CheckBoxWrap>
      <Checkbox {...checkboxProps} />
    </CheckBoxWrap>
  )
}

export default CheckBoxCell
